/**
 * Extracts error message from various error types
 * @param error - Error object, string, or null/undefined
 * @param defaultMessage - Default message to return if error is not available
 * @returns Error message string
 */
export const getErrorMessage = (
  error: Error | string | null | undefined,
  defaultMessage = 'An error occurred'
): string => {
  if (!error) {
    return defaultMessage;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return error.message || defaultMessage;
  }

  // Handle objects with message property
  if (typeof error === 'object' && 'message' in error) {
    return (error as { message?: string }).message || defaultMessage;
  }

  return defaultMessage;
};
